import React from 'react';
import UpdatableCard from "./UpdatableCard";
import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";
import {InputGroup} from "react-bootstrap";
import {btnoptions, ButtonList} from "../ui/ButtonList";
import {formatStats} from "../../helpers/helpers";
import BootstrapTable from 'react-bootstrap-table-next';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {useMediaQuery} from "../../hooks/useMediaQuery";

function RecipesCard({title, recipes, showModal, day: _day}) {
    const [text, setText] = React.useState("");
    const [show_100g, setShow100g] = React.useState(false);
    const isMobile = useMediaQuery('(max-width: 767px)');

    recipes = recipes.filter((recipe) => recipe.name.toLowerCase().includes(text.toLowerCase()))
    if (recipes.length > 50) {
        recipes = recipes.slice(0, 50)
        title += " (showing first 50)"
    }

    let recipesdata = recipes.map((value, _index) => {
        const formattedStats = formatStats(value.stats)
        const suffix = show_100g ? "_100g" : "_serving"
        const buttonList = <ButtonList item={value}
                                       options={[btnoptions.EDIT, btnoptions.CLONE, btnoptions.DELETE]}
                                       onEdit={() => showModal(value)}
                                       onClone={() => showModal(value, true)}
                                       isDropdown={false}/>

        return {
            "name": value["name"],
            "energy": {"data": formattedStats["energy" + suffix], "sortValue": value.stats["energy-kcal"]},
            "carbs": {"data": formattedStats["carbohydrates" + suffix], "sortValue": value.stats["carbohydrates"]},
            "fat": {"data": formattedStats["fat" + suffix], "sortValue": value.stats["fat"]},
            "protein": {"data": formattedStats["proteins" + suffix], "sortValue": value.stats["proteins"]},
            "score": {"data": formattedStats["score"], "sortValue": value.stats["proteins"] * 1000 / value.stats["energy-kcal"]},
            "actions": buttonList
        }
    });

    const sortCaret = (order, _column) => {
        if (!order) return (<span><FontAwesomeIcon icon={solid('caret-up')}/>
        <FontAwesomeIcon icon={solid('caret-down')}/></span>);
        else if (order === 'asc') return (<FontAwesomeIcon icon={solid('caret-up')}/>);
        else if (order === 'desc') return (<FontAwesomeIcon icon={solid('caret-down')}/>);
        return null;
    }

    let columns = [{
        dataField: 'name',
        text: 'Name',
        sort: true,
        sortCaret: sortCaret,
    }, {
        dataField: 'energy',
        text: 'Energy',
        sort: true,
        sortCaret: sortCaret,
        formatter: (cell, row) => row["energy"]["data"],
        sortValue: (cell, row) => row["energy"]["sortValue"]
    }, {
        dataField: 'carbs',
        text: 'Carbs',
        sort: true,
        sortCaret: sortCaret,
        formatter: (cell, row) => row["carbs"]["data"],
        sortValue: (cell, row) => row["carbs"]["sortValue"]
    }, {
        dataField: 'fat',
        text: 'Fat',
        sort: true,
        sortCaret: sortCaret,
        formatter: (cell, row) => row["fat"]["data"],
        sortValue: (cell, row) => row["fat"]["sortValue"]
    }, {
        dataField: 'protein',
        text: 'Protein',
        sort: true,
        sortCaret: sortCaret,
        formatter: (cell, row) => row["protein"]["data"],
        sortValue: (cell, row) => row["protein"]["sortValue"]
    }, {
        dataField: 'score',
        text: 'Score',
        sort: true,
        sortCaret: sortCaret,
        formatter: (cell, row) => row["score"]["data"],
        sortValue: (cell, row) => row["score"]["sortValue"]
    }, {
        dataField: 'actions',
        text: 'Actions'
    }];

    if (isMobile) {
        columns = columns.filter(col => col.dataField === 'name' || col.dataField === 'actions')
    }

    return (<UpdatableCard title={title} empty={false}>
        <Form.Check
            type="switch"
            label="Show per 100g instead of serving"
            id="custom-switch"
            onChange={(e) => setShow100g(e.target.checked)}
            checked={show_100g}
        />
        <InputGroup style={{marginBottom: 5 + "px"}}>
            <Form.Control placeholder={"Search recipes..."}
                          onChange={(event) => setText(event.target.value)}/>
            <Button onClick={(e) => {
                e.preventDefault();
                showModal()
            }}>
                Add new recipe
            </Button>
        </InputGroup>
        <BootstrapTable striped bordered hover columns={columns} data={recipesdata} keyField={"name"}/>
    </UpdatableCard>);
}

export default RecipesCard